import React, { Component } from "react";
import _ from 'lodash';
import { Table, Row, Col , Input} from "reactstrap";

// UI Components
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import { getMessage } from "CONFIG/i18n";

import Pagination from "react-js-pagination";

import "../AdminDashboard.less";
import "./SessionList.less";

import { getBootstrapTableOptions, getUserNameForSelectedLanguage } from "UTILS/Utility";

import { PAGE_COUNT } from "UTILS/Constants";
import { formatDateByLocale, getTimeInLocaleTimezone } from "UTILS/DateUtils";

import { userAction } from "CONFIG/ActionFactory";

import ic_checked from "ASSETS/Images/check.svg";

export default class SessionList extends Component{

  constructor(props){
    super(props);
    this.state={
      showSessionDetailsFlag: 1,
    };
  }

  fetchTableData=(page)=>{
    this.props.fetchSessionsList(
      page - 1,
      this.props.sessionListPageSize,
      this.props.searchKey ? this.props.searchKey : undefined
    );
    const tableData = document.querySelector(".reportListContainer .react-bs-container-body");
    tableData.scrollTop = 0;
  }

  showSessionDetails = () =>{
    this.setState({ showSessionDetailsFlag : 0 });
  }

  renderPageCountOptions = () => {
    return PAGE_COUNT.map(count => {
      return <option value={count} key={"page_" + count}>{count}</option>
    })
  }

  sessionNameFormat = (cell, row) => {
    return (
      <div>
        <label
          className="nameEllipsis cursorPointer"
          onClick={() => {
            this.props.getSessionInvitiesAndSessionDetails(row.session_key)
          }}
          style={{textDecoration: "underline"}}
          title={row.session_name}
        >
          {row.session_name}
        </label>
      </div>
    )
  }

  agentNameFormat = (cell, row) => {
    const userName = getUserNameForSelectedLanguage(this.props.language, row.owner);
    return (
      <div>
        <label
          className="nameEllipsis"
          title={userName}>
          {userName}
        </label>
      </div>
    )
  }

  dateFormat = (cell, row) => {
    return (
      <div className="nameEllipsis">
        {row.start_time ?` ${formatDateByLocale(row.start_time, this.props.language)} ${getTimeInLocaleTimezone(row.start_time)}` : "--"}
      </div>
    )
  }

  statusFormat = (cell, row) => {
    return (
      <label className="nameEllipsis" title={getMessage(row.status)}>
        {getMessage(row.status)}
      </label>
    )
  }

  isRecordingFormat = (cell, row) => {
    return (
      row.recording ? <img
        src={ic_checked}
        className="recordingCheckImg"
      /> : null
    )
  }

  render(){
    const { sessionListCurrentPageNo, sessionsList, sessionsCount } = this.props;
    const displayPage = sessionListCurrentPageNo + 1;
    return(
      (this.state.showSessionDetailsFlag) ?
        <div className="reportListContainer">
          <BootstrapTable
            data={sessionsList}
            tableHeaderClass="tableHeader"
            tableBodyClass='tableBody'
            containerClass='organisationsList reportList'
            tableContainerClass=''
            headerContainerClass=''
            bodyContainerClass=''
            bordered={false}
            options={getBootstrapTableOptions()}
            printable
          >
            <TableHeaderColumn
              dataField='session_key'
              hidden={true}
              isKey>
              {getMessage("SESSION_KEY")}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={this.sessionNameFormat}
              dataField='session_name'
              // width="25"
              dataSort={true}
            >
              {getMessage("SESSION_NAME")}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={this.agentNameFormat}
              dataField='owner'
              dataSort={true}
              // width="15"
            >
              {getMessage("ROLE_AGENT")}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={this.dateFormat}
              dataField='start_time'
              dataSort={true}
              // width="20"
            >
              {getMessage("DATE")}
            </TableHeaderColumn>
            <TableHeaderColumn
              // width="15"
              dataSort={true}
              dataField='duration'
              dataFormat={(cell, row) => {
                return (
                  <div> {row.duration || '--'}</div>
                )
              }}
            >
              {getMessage("DURATION")} <span>({getMessage("MINUTES")})</span>
            </TableHeaderColumn>
            <TableHeaderColumn
              // width="15"
              dataSort={true}
              dataField='status'
              dataFormat={this.statusFormat}
            >
              {getMessage("STATUS")}
            </TableHeaderColumn>
            <TableHeaderColumn
              // width="15"
              dataSort={true}
              dataField='recording'
              dataFormat={this.isRecordingFormat}
            >
              {getMessage("REPORTS_RECORDING")}
            </TableHeaderColumn>
          </BootstrapTable>

          {/* <Table responsive  className="organisationsList reportList">
            <thead className="tableHeader">
              <tr>
                <th style={{ width: "18%" }}>{getMessage("SESSION_NAME")}</th>
                <th style={{ width: "15%" }}>{getMessage("DATE")}</th>
                <th style={{ width: "15%" }}>{getMessage("ROLE_AGENT")}</th>
                <th style={{ width: "12%" }}>{getMessage("DURATION")} <span className="newLine">({getMessage("MINUTES")})</span></th>
                <th style={{ width: "12%" }}>{getMessage("STATUS")}</th>
              </tr>
            </thead>

            <tbody className="tableBody">

              {_.map(sessionsList,(session,index)=>{
                return(
                  <tr className="reportsTableRowHeight" key={index}>
                    <td
                      className="nameEllipsis"
                      onClick={() => {this.props.getSessionInvitiesAndSessionDetails(session.session_key)}}>
                      <label style={{textDecoration: "underline"}} className="cursorPointer">{session.session_name}</label>
                    </td>
                    <td className="nameEllipsis"> {formatDateByLocale(session.created_time, this.props.language)} {getTimeInLocaleTimezone(session.created_time)}</td>
                    <td> {session.owner} </td>
                    <td> {session.duration || '--'}</td>
                    <td> {getMessage(session.status)}</td>
                  </tr>
                )
              })
              }
            </tbody>
          </Table> */}

          <div className="reportsTableMargin">
            <Row className="paginationRow"> 
              <Col xs={4} className="paginationEntries">
                {getMessage("PAGINATION_TOTAL_ENTRIES",
                  {from: sessionListCurrentPageNo * this.props.sessionListPageSize + 1,
                    to: sessionListCurrentPageNo * this.props.sessionListPageSize + this.props.sessionListPageSize < sessionsCount ? sessionListCurrentPageNo * this.props.sessionListPageSize + this.props.sessionListPageSize : sessionsCount,
                    totalCount: sessionsCount})}
              </Col> 
              <Col xs={4} className="pagination">
                {sessionsCount > this.props.sessionListPageSize ?
                  <Pagination
                    activePage={displayPage}
                    itemsCountPerPage={this.props.sessionListPageSize}
                    totalItemsCount={sessionsCount}
                    pageRangeDisplayed={3}
                    onChange={this.fetchTableData}
                    itemClass="page-item"
                    linkClass="page-link"
                  /> : null
                }
              </Col>
              <Col xs={4} className="pageCount">
                {sessionsCount > PAGE_COUNT[0] &&
                  <Input type="select" className="inputFormControl selectText form-control border"
                    onChange={(e)=>{
                      userAction.saveSessionListPageSize(parseInt(e.target.value))
                      this.props.fetchSessionsList(0, e.target.value);
                    }}
                    value={this.props.sessionListPageSize}
                  >
                    {this.renderPageCountOptions()}
                  </Input>
                }
              </Col>
            </Row>
          </div>
        </div>:null
    )

  }

}
